<template>
  <div @click="statusPopoverVisible = false">
    <div class="container-search">
      <el-form
        inline
        size="mini"
        label-width="70px"
        class="table-search-part more-search-part inline-wrapper"
        @submit.native.prevent="handleQuery()"
      >
        <div class="search-left">
          <el-form-item label="User ID">
            <el-input
              v-model="userIds"
              clearable
              placeholder="User ID"
              oninput="value=value.replace(/[^\d,]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="Level" class="level-box">
            <el-select
              v-model="queryData.userLevelIds"
              multiple
              filterable
              collapse-tags
              placeholder="Level"
              :popper-append-to-body="false"
              style="border-radius: 4px 0 0 4px;"
            >
              <el-option
                v-for="item in levelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="userLevelExpire-box">
            <el-checkbox v-model="queryData.userLevelExpire">Expire</el-checkbox>
          </el-form-item>
          <!-- <el-form-item class="userLevelExpire-box">
            <el-select
              v-model="queryData.userLevelExpire"
              multiple
              filterable
              collapse-tags
              placeholder="userLevelExpire"
              :popper-append-to-body="false"
              style="border-radius: 4px 0 0 4px;"
            >
              <el-option
                v-for="item in userLevelExpireList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item label="User Limit">
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                Select a Channel to search for users
                <br />with applied channel configurations
              </div>
              <el-select v-model="queryData.levelId" filterable clearable placeholder="User Limit">
                <el-option
                  v-for="item in sortedArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="Odds Level">
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                Select a Channel to search for users
                <br />with applied channel configurations
              </div>
              <el-select
                v-model="queryData.oddsLevel"
                clearable
                filterable
                placeholder="Odds Level"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in oddList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="Margin Odds Level">
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                Select a Channel to search for users
                <br />with applied channel configurations
              </div>
              <el-select
                v-model="queryData.marginOddsLevel"
                clearable
                filterable
                placeholder="Margin Odds Level"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in oddList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="Self-Risk">
            <el-select v-model="queryData.selfRisk" clearable>
              <el-option
                v-for="item in selfRiskList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Delayed Settle">
            <el-select v-model="queryData.delaySettled" clearable>
              <el-option
                v-for="item in delayedSettleList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Label" class="label-box">
            <el-select
              v-model="queryData.labelIds"
              multiple
              filterable
              collapse-tags
              placeholder="Label"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in lableList"
                :key="item.labelId"
                :label="item.labelName"
                :value="item.labelId"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="Alert">
            <el-select
              v-model="queryData.isAlert"
              placeholder="Alert"
              clearable
            >
              <el-option
                v-for="item in alertList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item label="Status">
            <el-select v-model="queryData.status" clearable>
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :value="item.id"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Channel">
            <el-select
              v-model="queryData.merchantId"
              placeholder="Merchant"
              clearable
              filterable
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item,index) in merchatList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="OddsDrop Template">
            <el-select v-model="queryData.oddsDropFactor" clearable>
              <el-option
                v-for="item in oddsDropFactorList"
                :key="String(item.id)"
                :value="String(item.id)"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Delayed Order">
            <el-select v-model="queryData.baseDelayed" clearable>
              <el-option
                v-for="item in delayedOrderList"
                :key="String(item.id)"
                :value="String(item.id)"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Level Update Time" label-width="120px">
            <el-date-picker
              v-model="userLevelUpdateTime"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm"
              :default-time="['00:00:00', '23:59:59']"
              value-format="timestamp"
              range-separator="-"
              start-placeholder="Start time"
              end-placeholder="End time"
              clearable
            />
          </el-form-item>
          <el-form-item label="Last Bet Time" label-width="70px">
            <el-date-picker
              v-model="userLastBetTime"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm"
              :default-time="['00:00:00', '23:59:59']"
              value-format="timestamp"
              range-separator="-"
              start-placeholder="Start time"
              end-placeholder="End time"
              clearable
            />
          </el-form-item>
        </div>
        <div class="search-right inline-right">
          <el-button class="search-btn" @click="handleQuery()">Search</el-button>
          <el-button class="clear-btn" @click="handleClearQuery()">Clear</el-button>
          <el-button class="search-btn" @click="showQueryDialog()">Save Condition</el-button>
          <div class="search-number">
            <el-tooltip v-for="(query, idx) in userQueryList" :key="idx" :disabled="!query.remark" class="item" effect="dark" :content="query.remark" placement="top">
              <el-button class="query-btn" @click="querySearchEdit(query.request)">{{query.number}}</el-button>
            </el-tooltip>
          </div>
        </div>
      </el-form>
    </div>

    <div class="middle-btn inline-wrapper" style="display:flex;">
      <el-button class="lebel-risk-export-btn" @click="isShow(8, 'Batch Check User')">Check</el-button>
      <!-- <el-button class="lebel-risk-export-btn" @click="isShow(1)">Add Label</el-button> -->
      <el-button
        class="lebel-risk-export-btn"
        @click="isShow(2, 'Batch Modifying User Limit')"
      >Modify User Limit</el-button>
      <el-button
        class="lebel-risk-export-btn"
        @click="isShow(6, 'Batch Modifying Level')"
      >Modify Level</el-button>
      <el-button
        class="lebel-risk-export-btn"
        @click="isShow(7, 'Batch Editing Self-Risk')"
      >Edit Self-Risk</el-button>
      <el-button
        class="lebel-risk-export-btn"
        @click="isShow(11, 'Batch Editing Delay Settle')"
      >Edit Delay Settle</el-button>
      <el-button
        class="lebel-risk-export-btn"
        @click="isShow(9, 'Batch Editing Odds Level')"
      >Edit Odds Level</el-button>
      <el-button
        class="lebel-risk-export-btn"
        style="width: 160px;"
        @click="isShow(12, 'Batch Editing Margin Odds Level')"
      >Edit Margin Odds Level</el-button>
      <el-button
        class="lebel-risk-export-btn"
        @click="isShow(10, 'Batch Edit Delayed Order')"
      >Edit Delayed Order </el-button>
      <div style="flex-grow: 1;text-align: right;">
        <el-button
          class="lebel-risk-export-btn"
          id="download"
          @click="handleExport()"
          :loading="exportLoading"
        >
          <i class="icon iconfont iconProperty1xiazai"></i>
          Export
        </el-button>
      </div>
    </div>

    <div class="table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        :stripe="true"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column type="selection" align="center" width="36"></el-table-column>
        <el-table-column label="User ID" prop="userId" min-width="91">
          <template v-slot="{ row }">
            <div>{{ row.userId }}</div>
            <el-popover
              placement="bottom-start"
              width="320"
              trigger="hover"
              popper-class="check-popper"
            >
              <div class="check-hint" v-show="row.remark" slot="reference">C</div>
              <div class="text">{{ row.remarkOperator }}</div>
              <div class="update-time">{{ formatUtc(row.remarkUpdateTime) }}</div>
              <div class="text">{{ row.remark }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="Channel" prop="merchantName" min-width="130">
          <template v-slot="{row}">
            <div
              class="level-name-cell"
              :style="{color:row.merchantFontColor,background: row.merchantBgColor}"
            >{{row.merchantName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Level" prop="userLevelName" min-width="115">
          <template v-slot="{ row }">
            <div
              class="level-name-cell"
              :style="{
                backgroundColor: getLevelBackgroundColor(row.userLevelId),
                color: getLevelFontColor(row.userLevelId)
              }"
            >
              <el-tooltip class="item" effect="dark" :content="row.userLevelName" placement="top">
                <span>{{ row.userLevelName }}</span>
              </el-tooltip>
            </div>
            <span v-if="row.userLevelExpire" style="color:#909399;">(Expired)</span>
          </template>
        </el-table-column>
        <el-table-column label="User Limit" min-width="145" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div>
              <span class="odds-tag" v-if="row.levelSource == 2">C</span>
              <span
                class="odds-tag"
                v-if="row.levelIdByFb && Number(row.levelIdByFb) !== Number(row.originalLevelId) && Number(row.levelSource) !== 2"
              >M</span>
              {{ (row.userLevelId == 22 && row.levelSource == 2) ? row.merchantNewUserLevelName : row.levelName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Label"
          prop="labelName"
          min-width="150"
          :show-overflow-tooltip="true"
        >
          <template v-slot="{ row }">{{ getLabelNames(row)}}</template>
        </el-table-column>
        <el-table-column label="Odds Level" min-width="145" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div v-if="row.oddsLevelSource == 3">
              <span class="odds-tag">C</span>
              {{ feachOddsLevel(row.oddsLevel) }}
            </div>
            <div v-if="row.oddsLevelSource == 1">
              <span class="odds-tag" v-if="row.oddsLevelOperationService == 2">M</span>
              {{ feachOddsLevel(row.oddsLevel) }}
            </div>
            <div v-if="row.oddsLevelSource == 2">
              <span class="odds-tag">L</span>
              {{ feachOddsLevel(row.oddsLevel) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Margin Odds Level" min-width="145" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div v-if="row.marginOddsLevelSource == 3">
              <span class="odds-tag">C</span>
              {{ feachOddsLevel(row.marginOddsLevel) }}
            </div>
            <div v-if="row.marginOddsLevelSource == 1">
              <span class="odds-tag" v-if="row.marginOddsLevelOperationService == 2">M</span>
              {{ feachOddsLevel(row.marginOddsLevel) }}
            </div>
            <div v-if="row.marginOddsLevelSource == 2">
              <span class="odds-tag">L</span>
              {{ feachOddsLevel(row.marginOddsLevel) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="OddsDrop Template" min-width="145" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div>{{ row.oddsDropGroupName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Delayed Order" min-width="145" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div>{{ row.baseDelayed }}</div>
          </template>
        </el-table-column>
        <el-table-column min-width="150" label="Last Bet Time">
          <template v-slot="{ row }">
            <div v-if="row.lastBetTime">{{ formatUtc(row.lastBetTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column min-width="150" label="Level Update Time">
          <template v-slot="{ row }">
            <div v-if="row.userLevelUpdateTime">{{ formatUtc(row.userLevelUpdateTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column min-width="201" label="Remark" prop="remark" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="Self-Risk" min-width="80" align="center">
          <template slot-scope="scope">
            <div class="is-text-switch">
              <el-switch
                v-model="scope.row.selfRisk"
                :active-value="1"
                :inactive-value="0"
                active-color="#00A791"
                inactive-color="#D5D9E0"
                :width="48"
                @change="handleSelfRisk(scope.row)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Delayed Settle" min-width="120" align="center">
          <template slot-scope="scope">
            <div class="is-text-switch">
              <el-switch
                v-model="scope.row.delaySettled"
                :active-value="1"
                :inactive-value="0"
                active-color="#00A791"
                inactive-color="#D5D9E0"
                :width="48"
                @change="handleDelaySettled(scope.row)"
              />
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Alert" min-width="65" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isAlert"
              :active-value="true"
              :inactive-value="false"
              active-color="#00A791"
              inactive-color="#D5D9E0"
              :width="35"
              @change="handleAlert(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>-->
        <el-table-column label="Status" min-width="122" align="center">
          <template slot-scope="scope">
            <el-popover
              ref="statusPopoverRef"
              placement="bottom-end"
              trigger="manual"
              :value="
                statusPopoverVisible && activeStatusPopover === scope.row.userId
              "
              @after-leave="handleStatusPopoverReset"
            >
              <div
                class="status-popver"
                slot="reference"
                @click.stop="toggleStatusPopover(scope.row)"
              >
                <div
                  :class="[
                    'tag',
                    scope.row.status === 0 ? 'tag--suspend' : '',
                    scope.row.status === 1 ? 'tag--active' : '',
                    scope.row.status === 2 ? 'tag--block' : ''
                  ]"
                >{{ getStatusName(scope.row.status) }}</div>
                <i
                  class="el-icon-arrow-down"
                  :class="{
                    'icon-status': activeStatusPopover === scope.row.userId
                  }"
                />
              </div>
              <div class="el-select-dropdown__wrap el-scrollbar__wrap">
                <div class="el-scrollbar__view el-select-dropdown__list">
                  <div
                    v-for="item in statusList"
                    :key="item.id"
                    :class="[
                      status === item.id ? 'is-selected' : '',
                      'el-dropdown-menu__item'
                    ]"
                    @click="handleStatusPopoverClick(item)"
                  >{{ item.label }}</div>
                </div>
              </div>
              <div class="popover-buttons">
                <el-button type="text" @click="handleStatusPopoverReset">Cancel</el-button>
                <el-button type="primary" @click="handleStatusPopoverSave(scope.row)">Save</el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column
          min-width="150"
          label="odds Drop Factor"
          align="center"
        >
          <template v-slot="{ row }">
            <div>{{ row.oddsDropFactor }}</div>
          </template>
        </el-table-column>-->
        <el-table-column label="Operation" fixed="right" min-width="200">
          <template v-slot="{ row }">
            <div>
              <el-button class="table-inner-btn" @click="handleViewDetail(row)">Details</el-button>
              <el-button class="table-inner-btn" @click="isShow(8, 'Check User', row, true)">Check</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <div class="pagination-btn">
        <!-- <el-button
          class="status-alert-btn"
          @click="isShow(3, 'Open Alert', true)"
          >Alert</el-button
        >
        <el-button
          class="status-alert-btn"
          @click="isShow(3, 'Close Alert', false)"
          >Close Alert</el-button
        >-->
        <el-button
          class="status-alert-btn status-active-btn"
          @click="isShow(4, 'Switch to Active', 1)"
        >Active</el-button>
        <el-button
          class="status-alert-btn status-suspend-btn"
          @click="isShow(4, 'Switch to Suspend', 0)"
        >Suspend</el-button>
        <el-button
          class="status-alert-btn status-block-btn"
          @click="isShow(4, 'Switch to Block', 2)"
        >Block</el-button>
      </div>
      <el-pagination
        class="inline-right parlay-pagination"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.pageSize"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total,slot, sizes, prev, pager, next, jumper"
      >
        <slot>
          <span
            v-if="slotStatus"
            style="text-align: left;min-width: 10px;
    display: inline-block;
    margin-right: 10px;color: #606266;"
          >+</span>
        </slot>
      </el-pagination>
    </div>

    <dia ref="dialogDom" class="label-dialog">
      <!-- 添加label1 修改riskLevel2 -->
      <div class="select-down-wrapper">
        <el-form label-width="120px" :label-position="num === 8 ? 'top' : 'left'">
          <el-form-item v-if="showSelfRiskSwitchToYesTip">User's Self-Risk will switch to YES</el-form-item>
          <el-form-item label="User Limit:" v-if="num == 2">
            <el-select
              v-model="levelQueryData.levelId"
              placeholder="User Limit"
              :popper-append-to-body="false"
              @change="getLevel(levelQueryData.levelId)"
            >
              <el-option
                v-for="item in sortedArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Label:" v-if="num == 1">
            <el-select
              v-model="lableQueryData.labelIds"
              multiple
              :multiple-limit="5"
              collapse-tags
              placeholder="Label"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in lableList"
                :key="item.labelId"
                :label="item.labelName"
                :value="item.labelId"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 批量修改等级 -->
          <el-form-item label="Level:" v-if="num == 6">
            <el-select
              v-model="batchUpdateLevel.userLevelId"
              clearable
              filterable
              placeholder="Level"
              :popper-append-to-body="false"
            >
              <el-option label="Blank" value="0"></el-option>
              <el-option
                v-for="item in levelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 批量修改风险自负 -->
          <el-form-item label="Self-Risk:" v-if="num == 7">
            <el-select
              v-model="batchUpdateSelfRisk.selfRisk"
              clearable
              filterable
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in selfRiskList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Delay Settle:" v-if="num == 11">
            <el-select
              v-model="batchUpdateDelaySettled.delaySettled"
              clearable
              filterable
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in delayedSettleList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <!-- 修改用户备注 -->
          <el-form-item v-if="num == 8">
            <div class="remark-warp">
              <div class="title">Remark</div>
              <el-input
                type="textarea"
                :rows="14"
                maxlength="240"
                show-word-limit
                placeholder="Input"
                v-model="batchUpdateRemark.remark"
                resize="none"
              />
            </div>
          </el-form-item>
          <!-- 批量修改赔率等级 -->
          <el-form-item label="Odds Level:" v-if="num == 9">
            <el-select
              v-model="batchUpdateOddsLevel.oddsLevel"
              clearable
              filterable
              placeholder="Odds Level"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddsLevelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 批量修改赔率等级 -->
          <el-form-item label="Margin Odds Level:" v-if="num == 12">
            <el-select
              v-model="batchUpdateMarginOddsLevel.marginOddsLevel"
              clearable
              filterable
              placeholder="Margin Odds Level"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddsLevelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Delayed Order:" v-if="num == 10">
            <el-select
              v-model="batchUpdateBaseDelayed.baseDelayed"
              clearable
              filterable
              placeholder="Delayed Order"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in delayedOrderList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button
            class="search-btn"
            @click="handlebBatchEditUserLimit()"
            v-if="num == 2"
            :loading="userLimit"
          >Confirm</el-button>
          <el-button
            class="search-btn"
            @click="handleLableAdd()"
            v-if="num == 1"
            :loading="addLable"
          >Confirm</el-button>
          <el-button class="search-btn" @click="switchAlert()" v-if="num == 3">Confirm</el-button>
          <el-button class="search-btn" @click="switchBatchStatus()" v-if="num == 4">Confirm</el-button>
          <el-button
            class="search-btn"
            @click="BatchLevel()"
            v-if="num == 6"
            :loading="modifyLevel"
          >Confirm</el-button>
          <el-button
            class="search-btn"
            @click="handleBatchEditSelfRisk()"
            v-if="num == 7"
            :loading="selfRiskUser"
          >Confirm</el-button>
          <el-button
            class="search-btn"
            @click="handleBatchEditDelaySettle()"
            v-if="num == 11"
            :loading="delaySettleUser"
          >Confirm</el-button>
          <el-button
            class="search-btn"
            @click="handleBatchUpdateRemark()"
            v-if="num == 8"
            :loading="checkUser"
          >Confirm</el-button>
          <el-button
            class="search-btn"
            @click="BatchOddsLevel()"
            v-if="num == 9"
            :loading="oddsLevelUser"
          >Confirm</el-button>
          <el-button
            class="search-btn"
            @click="BatchMarginOddsLevel()"
            v-if="num == 12"
            :loading="marginOddsLevelUser"
          >Confirm</el-button>
          <el-button
            class="search-btn"
            @click="BatchDelayedOrder()"
            v-if="num == 10"
            :loading="delayedOrderLoading"
          >Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
    </dia>

    <dia ref="saveDialogDom" class="label-dialog">
      <div class="select-down-wrapper">
        <el-form label-width="50px">
          <el-form-item v-for="(item, idx) in userQueryListEdit" :key="item.number" :label="item.number+''">
            <div class="query-item">
              <!-- <div class="title">Remark</div> -->
              <el-input
                maxlength="240"
                placeholder="Remark"
                :value="item.remark"
                class="remarkInput"
                @input="(event) => remarkInput(event, idx)"
              />
              <el-button class="save-btn search-btn" @click="saveCondition(item)">Save</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import { findAllLabel } from "@/api/lable";
import { getList } from "@/api/oddsDrop";
import {
  getMemberList,
  changeStatus,
  changeRemarkBatch,
  changeBatchStatus,
  changeAlert,
  getAllRiskLevel,
  getLevelUpdate,
  getLableUpdate,
  updateOddsLevel,
  updateMarginOddsLevel,
  batchUpdateUserBaseDelayed,
  getExport,
  getMerchat,
  batchUpdateUserLevel,
  getLevelList,
  changeSelfRiskBatch,
  changeDelaySettleBatch,
  getUserQueryRequest,
  setUserQueryCommon,
  setUserQueryPersonal
} from "@/api/member";

export default {
  name: "MemberList",
  data() {
    return {
      userLimit: false,
      addLable: false,
      checkUser: false,
      modifyLevel: false,
      selfRiskUser: false,
      delaySettleUser: false,
      oddsLevelUser: false,
      marginOddsLevelUser: false,
      exportLoading: false,
      delayedOrderLoading: false,
      list: [],
      riskLevelList: [],
      lableList: [],
      lableListAll: [],
      levelList: [],
      oddsLevelList: [
        { id: 0, name: "Config" },
        { id: 1, name: "A" },
        { id: 2, name: "B" },
        { id: 3, name: "C" },
        { id: 4, name: "D" },
        { id: 5, name: "E" },
        { id: 6, name: "F" },
        { id: 7, name: "G" }
      ],
      delayedOrderList:[
        {id:'0', name:'0'},
        {id:'6', name:'6s'},
        {id:'9', name:'9s'},
        {id:'12', name:'12s'},
        {id:'15', name:'15s'},
        {id:'20', name:'20s'},
        {id:'25', name:'25s'},
        {id:'30', name:'30s'},
      ],
      merchatList: [],
      total: 0,
      loading: false,
      queryData: {
        current: 1,
        pageSize: 50,
        merchantId: "",
        oddsLevel: "",
        deviceId: "",
        levelId: "",
        labelIds: [],
        userLevelIds: [],
        userIds: [],
        isAlert: "",
        status: "",
        selfRisk: "",
        delaySettled: "",
        oddsDropFactor: "",
        baseDelayed: "",
        userLevelUpdateStartTime: "",
        userLevelUpdateEndTime: "",
        lastBetStartTime: "",
        lastBetEndTime: "",
        userLevelExpire: "",
        marginOddsLevel: ""
      },
      oddsDropFactorList: [],
      slotStatus: false,
      totalNum: 100000,
      userLevelUpdateTime: [],
      userLastBetTime: [],
      userIds: "",
      levelQueryData: {
        userIds: [],
        levelIds: [],
        levelId: ""
      },
      lableQueryData: {
        userIds: [],
        labelIds: []
      },
      batchUpdateLevel: {
        ids: [],
        userLevelId: ""
      },
      batchUpdateOddsLevel: {
        userIds: [],
        oddsLevel: ""
      },
      batchUpdateMarginOddsLevel: {
        userIds: [],
        marginOddsLevel: ""
      },
      batchUpdateSelfRisk: {
        ids: [],
        selfRisk: ""
      },
      batchUpdateDelaySettled: {
        ids: [],
        delaySettled: ""
      },
      batchUpdateRemark: {
        ids: [],
        remark: ""
      },
      batchUpdateBaseDelayed: {
        ids: [],
        baseDelayed: ""
      },
      oddList: [
        { id: 1, label: "A" },
        { id: 2, label: "B" },
        { id: 3, label: "C" },
        { id: 4, label: "D" },
        { id: 5, label: "E" },
        { id: 6, label: "F" },
        { id: 7, label: "G" }
      ],
      statusList: [
        {
          id: 1,
          label: "Active" // 启用
        },
        {
          id: 0,
          label: "Suspend" // 禁用（不可投注，可转出余额）
        },
        {
          id: 2,
          label: "Block" // 锁定（不可投注，不可转出余额）
        }
      ],
      alertList: [
        {
          id: true,
          label: "Open"
        },
        {
          id: false,
          label: "Closed"
        }
      ],
      selfRiskList: [
        {
          id: 1,
          label: "Yes"
        },
        {
          id: 0,
          label: "No"
        }
      ],
      delayedSettleList: [
        {
          id: 1,
          label: "Yes"
        },
        {
          id: 0,
          label: "No"
        }
      ],
      tableHeight: window.innerHeight,
      multipleSelection: [],
      num: "",
      title: "Batch Modifying Label",
      isAlert: "",
      status: "",
      showSelfRiskSwitchToYesTip: false,
      statusPopoverVisible: false,
      activeStatusPopover: "",
      userQueryList: [],
      userQueryListEdit: [],
    };
  },
  computed: {
    sortedArr() {
      const arrCopy = this.riskLevelList;
      arrCopy.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        // 先将 "Default" 排到最前面
        if (nameA === "DEFAULT") return -1;
        if (nameB === "DEFAULT") return 1;
        // 如果都是 "数字%group" 的形式，则按数字大小升序排列
        const regex = /(\d+)\s*%\s*group/i;
        const matchA = nameA.match(regex);
        const matchB = nameB.match(regex);
        if (matchA && matchB) {
          const numA = parseInt(matchA[1]);
          const numB = parseInt(matchB[1]);
          return numA - numB;
        }
        // 如果都不是 "数字%group" 的形式，则按字典序升序排列
        if (!matchA && !matchB) {
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        }
        // 如果只有一个是 "数字%group" 的形式，则将不是 "数字%group" 的排在前面
        return matchA ? -1 : 1;
      });
      return arrCopy;
    }
  },
  methods: {
    remarkInput(event, idx){
      this.$set(this.userQueryListEdit, idx, {...this.userQueryListEdit[idx], remark: event})
    },
    showQueryDialog(){
      this.userQueryListEdit = [...this.userQueryList];
      this.$refs["saveDialogDom"].isShowDia('Save Condition Setting', true, "500px");
    },
    querySearchEdit(request){
      try{
        let queryObj = JSON.parse(request)
        if(queryObj.toString() === '[object Object]'){
          if(queryObj.userLevelIds && queryObj.userLevelIds.length){
            let _userLevelIds = []
            queryObj.userLevelIds.forEach((levelId) => {
              if(this.levelList.findIndex(item => item.id == levelId) > -1){
                _userLevelIds.push(levelId)
              }
            })
            queryObj.userLevelIds = _userLevelIds
          }
          if(queryObj.labelIds && queryObj.labelIds.length){
            let _labelIds = []
            queryObj.labelIds.forEach((labelId) => {
              if(this.lableList.findIndex(item => item.labelId == labelId) > -1){
                _labelIds.push(labelId)
              }
            })
            queryObj.labelIds = _labelIds
          }
          if(queryObj.levelId){
            if(this.sortedArr.findIndex(item => item.id == queryObj.levelId) <= -1){
              delete queryObj.levelId
            }
          }
          if(queryObj.oddsDropFactor){
            if(this.oddsDropFactorList.findIndex(item => item.id == queryObj.oddsDropFactor) <= -1){
              delete queryObj.oddsDropFactor
            }
          }
          this.queryData = {
            current: 1,
            pageSize: 50,
            merchantId: "",
            oddsLevel: "",
            deviceId: "",
            levelId: "",
            labelIds: [],
            userLevelIds: [],
            userIds: [],
            isAlert: "",
            status: "",
            selfRisk: "",
            oddsDropFactor: "",
            userLevelUpdateStartTime: "",
            userLevelUpdateEndTime: "",
            lastBetStartTime: "",
            lastBetEndTime: "",
            userLevelExpire: "",
            ...queryObj
          }
          this.handleQuery()
        }
      }catch(err){
        
      }
    },
    async getUserQueryRequest(){
      let userQueryListTemp = []
      for(let i=1; i<11; i++){
        userQueryListTemp.push({
          "number": i,
          "common": i<=5,
          "request": "",
          "remark": ""
        })
      }
      this.userQueryList = userQueryListTemp
      const res = await getUserQueryRequest({});
      let data = res.data || [];
      data.forEach(item => {
        item.number = !item.common ? Number(item.number) + 5 : item.number
        let _idx = userQueryListTemp.findIndex(list => list.number == item.number)
        if(_idx > -1){
          userQueryListTemp[_idx] = item
        }
      })
      this.userQueryList = userQueryListTemp;
      this.userQueryListEdit = [...this.userQueryList];
    },
    getQueryData(){
      return JSON.stringify({
        userLevelIds: this.queryData.userLevelIds,
        labelIds: this.queryData.labelIds,
        levelId: this.queryData.levelId,
        oddsLevel: this.queryData.oddsLevel,
        selfRisk: this.queryData.selfRisk,
        status: this.queryData.status,
        oddsDropFactor: this.queryData.oddsDropFactor
      })
    },
    saveCondition(query) {
      let apiFn = query.number <= 5 ? setUserQueryCommon : setUserQueryPersonal
      apiFn({...query, request: this.getQueryData(), number: !query.common ? query.number - 5 : query.number}).then(res => {
        if(res.success){
          this.getUserQueryRequest()
          this.$message.success('saved');
        }
      })
    },
    getLevelFontColor(userLevelId) {
      const currentItem = this.levelList.find(
        item => Number(item.id) === Number(userLevelId)
      );
      if (!currentItem || !currentItem.fontColor) return "";
      return currentItem.fontColor;
    },
    getLevelBackgroundColor(userLevelId) {
      const currentItem = this.levelList.find(
        item => Number(item.id) === Number(userLevelId)
      );
      if (!currentItem || !currentItem.backgroundColor) return "";
      return currentItem.backgroundColor;
    },
    getStatusName(id) {
      return this.statusList.find(item => item.id === id)?.label;
    },
    handleStatusPopoverClick(option) {
      this.status = option.id;
    },
    handleStatusPopoverReset() {
      this.status = "";
      this.activeStatusPopover = "";
    },
    async handleStatusPopoverSave(row) {
      const res = await changeStatus({
        status: this.status,
        userId: row.userId
      });
      if (!res.data) {
        this.$message.error(res.message);
      }
      this.handleStatusPopoverReset();
      this.getList();
    },
    toggleStatusPopover(row) {
      this.statusPopoverVisible = true;
      this.status = row.status;
      this.activeStatusPopover =
        this.activeStatusPopover === row.userId ? "" : row.userId;
    },
    async handleOddsDropFactor() {
      try {
        const res = await getList({});
        this.oddsDropFactorList = res.data;
      } catch (error) {}
    },
    async handleBatchUpdateRemark() {
      this.checkUser = true;
      try {
        const res = await changeRemarkBatch(this.batchUpdateRemark);
        this.checkUser = false;
        if (!res.data) {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.checkUser = false;
      }

      this.Close();
      this.batchUpdateSelfRisk.selfRisk = "";
      this.batchUpdateDelaySettled.delaySettled = "";
      this.getList();
    },
    async getList() {
      if (!this.queryData.userLevelExpire) {
        this.queryData.userLevelExpire = "";
      }
      if (this.userLevelUpdateTime) {
        this.queryData.userLevelUpdateStartTime = this.userLevelUpdateTime[0];
        this.queryData.userLevelUpdateEndTime = this.userLevelUpdateTime[1];
      } else {
        this.queryData.userLevelUpdateStartTime = "";
        this.queryData.userLevelUpdateEndTime = "";
      }
      if (this.userLastBetTime) {
        this.queryData.lastBetStartTime = this.userLastBetTime[0];
        this.queryData.lastBetEndTime = this.userLastBetTime[1];
      } else {
        this.queryData.lastBetStartTime = "";
        this.queryData.lastBetEndTime = "";
      }
      this.loading = true;
      this.queryData = this.deleteEmptyQuery(this.queryData);
      if (this.queryData.userIds) {
        this.queryData.userIds = this.userIds
          ? this.userIds.replace(/\s+/g, "").split(",")
          : [];
      }
      if (this.userIds) {
        this.queryData.userLevelUpdateStartTime = "";
        this.queryData.userLevelUpdateEndTime = "";
        this.queryData.lastBetStartTime = "";
        this.queryData.lastBetEndTime = "";
      }
      try {
        const res = await getMemberList(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        if (Number(data.total) > this.totalNum) {
          this.slotStatus = true;
          this.total = this.totalNum;
        } else {
          this.slotStatus = false;
          this.total = Number(data.total);
        }
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    deleteEmptyQuery(data) {
      return Object.entries(data)
        .filter(
          ([key, value]) =>
            value || typeof value == "number" || typeof value == "boolean"
        )
        .reduce((prev, [key, value]) => {
          prev[key] = value;
          return prev;
        }, {});
    },
    async getRiskLevel() {
      const res = await getAllRiskLevel({});
      //const riskLevelArr = res.data.filter(obj => Number(obj.id) !== -1);
      const riskLevelArr = res.data;
      this.riskLevelList = riskLevelArr.map(item => ({
        id: item.id,
        name: item.riskLevel
      }));
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    feachOddsLevel(val) {
      let name = "";
      this.oddList.map(item => {
        if (item.id == val) {
          name = item.label;
        }
      });
      return name;
    },
    // lable下拉框
    async getLableList() {
      const res = await findAllLabel();
      let data = res.data || {};
      this.lableListAll = data;
      this.lableList = data.filter(label => label.labelId > 100028);
    },
    async getLevelList() {
      const res = await getLevelList({});
      let data = res.data || [];
      this.levelList = data;
    },
    // merchant下拉框
    async getMerchatList() {
      const res = await getMerchat({});
      let data = res.data || {};
      this.merchatList = data;
    },
    getLabelNames(row) {
      let { labelIds } = row;
      let labelArr = labelIds ? labelIds : [];
      let IdsArr = labelArr.map(i => {
        return i;
      });
      let str = "";
      this.lableListAll.map(item => {
        if (IdsArr.includes(item.labelId)) {
          str += item.labelName;
          str += "、";
        }
      });
      str = str.slice(0, -1); // 移除最后一个逗号
      return str;
    },
    // 搜索
    handleQuery() {
      this.getLevelList();
      this.queryData.current = 1;
      this.getList();
      // this.handleClear();
    },
    // 清除搜索
    handleClearQuery() {
      this.handleClear();
      //this.getList();
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.pageSize = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      return time ? this.$moment(+time).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    // 清空
    handleClear() {
      this.queryData = {
        ...this.queryData,
        current: 1,
        pageSize: 50,
        merchantId: "",
        deviceId: "",
        levelId: "",
        labelIds: [],
        userIds: [],
        status: "",
        isAlert: "",
        selfRisk: "",
        userLevelUpdateStartTime: "",
        userLevelUpdateEndTime: "",
        userLevelIds: [],
        oddsDropFactor: '',
        oddsLevel: '',
        marginOddsLevel: "",
        delaySettled: "",
        baseDelayed: "",
      };
      this.userLevelUpdateTime = [];
      this.userLastBetTime = [];
      
      this.userIds = "";
    },
    // 查看详情
    handleViewDetail(data) {
      this.$router.push({
        path: "/member/detail",
        query: { userId: data.userId, levelId: data.levelId }
      });
    },
    // 查看修改
    handleViewModify(data) {
      this.$router.push({
        path: "/member/modify",
        query: { userId: data.userId, levelId: data.levelId }
      });
    },
    // 表格选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    isShow(num, title, data, isInTable) {
      if (this.multipleSelection.length > 0 || isInTable) {
        this.levelQueryData.userIds = Object.values(this.multipleSelection).map(
          el => el.userId
        );
        this.levelQueryData.levelIds = Object.values(
          this.multipleSelection
        ).map(el => el.levelId);
        this.lableQueryData.userIds = Object.values(this.multipleSelection).map(
          el => el.userId
        );
        this.batchUpdateLevel.ids = Object.values(this.multipleSelection).map(
          el => el.userId
        );
        this.batchUpdateOddsLevel.userIds = Object.values(
          this.multipleSelection
        ).map(el => el.userId);
        this.batchUpdateMarginOddsLevel.userIds = Object.values(
          this.multipleSelection
        ).map(el => el.userId);
        this.batchUpdateSelfRisk.ids = Object.values(
          this.multipleSelection
        ).map(el => el.userId);
        this.batchUpdateDelaySettled.ids = Object.values(
          this.multipleSelection
        ).map(el => el.userId);
        this.batchUpdateBaseDelayed.ids = Object.values(
          this.multipleSelection
        ).map(el => el.userId);
        if (num === 8) {
          if (isInTable) {
            this.batchUpdateRemark.remark = data.remark
              ? data.remark
              : "无异常";
          } else {
            this.batchUpdateRemark.remark = isInTable ? data.remark : "无异常";
          }
          this.batchUpdateRemark.ids = isInTable
            ? [data.userId]
            : Object.values(this.multipleSelection).map(el => el.userId);
        }
        this.batchUpdateSelfRisk.selfRisk = "";
        this.batchUpdateDelaySettled.delaySettled = "";
        num == 3 ? (this.isAlert = data) : (this.status = data);
        this.num = num;
        this.title = title;
        this.$refs["dialogDom"].isShowDia(this.title, true, "480px");
      } else {
        this.$message({ message: "Must checked one", type: "warning" });
      }
    },
    async switchBatchStatus() {
      const res = await changeBatchStatus({
        status: this.status,
        userIds: this.levelQueryData.userIds
      });
      if (!res.data) {
        this.$message.error(res.message);
      }
      this.Close();
      this.getList();
    },
    handleSelfRisk(row) {
      let switchStr = `Switch SeIf-Risk to ${
        Number(row.selfRisk) === 1 ? "YES" : "NO"
      }？`;
      let flag = Number(row.selfRisk); //保存点击之后v-modeld的值(0，1)
      row.selfRisk = row.selfRisk === 1 ? 0 : 1; //保持switch点击前的状态
      this.$confirm(switchStr, {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(async () => {
          flag === 1 ? (row.selfRisk = 1) : (row.selfRisk = 0); // 这一步很重要，row.showState会根据flag的值开启或关闭开关
          const res = await changeSelfRiskBatch({
            selfRisk: flag,
            ids: row ? [row.userId] : this.levelQueryData.userIds
          });
          if (!res.data) {
            this.$message.error(res.message);
          }
          this.Close();
          this.getList();
        })
        .catch(() => {});
    },
    handleDelaySettled(row){
    let switchStr = `Switch Delay Settled to ${
        Number(row.delaySettled) === 1 ? "YES" : "NO"
      }？`;
      let flag = Number(row.delaySettled); //保存点击之后v-modeld的值(0，1)
      row.delaySettled = row.delaySettled === 1 ? 0 : 1; //保持switch点击前的状态
      this.$confirm(switchStr, {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(async () => {
          flag === 1 ? (row.delaySettled = 1) : (row.delaySettled = 0); // 这一步很重要，row.showState会根据flag的值开启或关闭开关
          const res = await changeDelaySettleBatch({
            delaySettled: flag,
            ids: row ? [row.userId] : this.levelQueryData.userIds
          });
          if (!res.data) {
            this.$message.error(res.message);
          }
          this.Close();
          this.getList();
        })
        .catch(() => {});
    },
    handleAlert(row) {
      let switchStr = row.isAlert ? "Open Alert" : "Close Alert";
      let flag = row.isAlert; //保存点击之后v-modeld的值(true，false)
      row.isAlert = !row.isAlert; //保持switch点击前的状态
      this.$confirm(switchStr, {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(() => {
        flag ? (row.isAlert = true) : (row.isAlert = false); // 这一步很重要，row.showState会根据flag的值开启或关闭开关
        this.switchAlert(row);
      });
    },
    async switchAlert(row) {
      this.isAlert = row ? row.isAlert : this.isAlert;
      let userIds = row ? [row.userId] : this.levelQueryData.userIds;
      const res = await changeAlert({
        isAlert: this.isAlert,
        userIds: userIds
      });
      if (!res.data) {
        this.$message.error(res.message);
      }
      this.Close();
      this.getList();
    },
    getLevel(e) {
      this.levelQueryData.levelId = e;
      const currentItem = this.riskLevelList.find(item => item.id === e);
      if (currentItem.name === "selfRisk") {
        this.showSelfRiskSwitchToYesTip = true;
      }
    },
    // 编辑 User Limit
    async handlebBatchEditUserLimit() {
      this.userLimit = true;
      try {
        const res = await getLevelUpdate(this.levelQueryData);
        this.userLimit = false;
      } catch (error) {
        this.userLimit = false;
      }
      this.Close();
      this.levelQueryData.levelId = "";
      this.getList();
    },
    // 添加label
    async handleLableAdd(data) {
      this.addLable = true;
      try {
        const res = await getLableUpdate(this.lableQueryData);
        this.addLable = false;
      } catch (error) {
        this.addLable = false;
      }
      this.Close();
      this.lableQueryData.labelIds = [];
      this.getList();
    },
    async BatchLevel(data) {
      this.modifyLevel = true;
      try {
        const res = await batchUpdateUserLevel(this.batchUpdateLevel);
        this.modifyLevel = false;
      } catch (error) {
        this.modifyLevel = false;
      }
      this.Close();
      this.batchUpdateLevel.userLevelId = "";
      this.getList();
    },
    async BatchOddsLevel(data) {
      this.oddsLevelUser = true;
      try {
        const res = await updateOddsLevel(this.batchUpdateOddsLevel);
        this.oddsLevelUser = false;
      } catch (error) {
        this.oddsLevelUser = false;
      }
      this.Close();
      this.batchUpdateOddsLevel.oddsLevel = "";
      setTimeout(() => {
        this.getList();
      }, 600);
    },
    async BatchMarginOddsLevel(data) {
      this.marginOddsLevelUser = true;
      try {
        const res = await updateMarginOddsLevel(this.batchUpdateMarginOddsLevel);
        this.marginOddsLevelUser = false;
      } catch (error) {
        this.marginOddsLevelUser = false;
      }
      this.Close();
      this.batchUpdateMarginOddsLevel.marginOddsLevel = "";
      setTimeout(() => {
        this.getList();
      }, 600);
    },
    async BatchDelayedOrder(data) {
      this.delayedOrderLoading = true;
      try {
        const res = await batchUpdateUserBaseDelayed(this.batchUpdateBaseDelayed);
        this.delayedOrderLoading = false;
      } catch (error) {
        this.delayedOrderLoading = false;
      }
      this.Close();
      this.batchUpdateBaseDelayed.baseDelayed = "";
      setTimeout(() => {
        this.getList();
      }, 600);
    },
    async handleBatchEditSelfRisk() {
      this.selfRiskUser = true;
      try {
        const res = await changeSelfRiskBatch(this.batchUpdateSelfRisk);
        this.selfRiskUser = false;
        if (!res.data) {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.selfRiskUser = false;
      }
      this.Close();
      this.batchUpdateSelfRisk.selfRisk = "";
      this.getList();
    },
    async handleBatchEditDelaySettle() {
      this.delaySettleUser = true;
      try {
        const res = await changeDelaySettleBatch(this.batchUpdateDelaySettled);
        this.delaySettleUser = false;
        if (!res.data) {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.delaySettleUser = false;
      }
      this.Close();
      this.batchUpdateDelaySettled.delaySettled = "";
      this.getList();
    },
    async handleExport() {
      try {
        this.exportLoading = true;
        if (this.total > 10000 && this.multipleSelection.length > 10000) {
          this.$message({
            message: "Maximum Download Is 10,000",
            type: "warning"
          });
          return false;
        }
        if (this.userLevelUpdateTime) {
          this.queryData.userLevelUpdateStartTime = this.userLevelUpdateTime[0];
          this.queryData.userLevelUpdateEndTime = this.userLevelUpdateTime[1];
        } else {
          this.queryData.userLevelUpdateStartTime = "";
          this.queryData.userLevelUpdateEndTime = "";
        }
        if (this.multipleSelection.length > 0) {
          this.queryData.userIds = Object.values(this.multipleSelection).map(
            el => el.userId
          );
        } else {
          this.queryData.userIds = this.userIds
            ? this.userIds.replace(/\s+/g, "").split(",")
            : [];
        }
        let timeZoneOffset = this.$moment().utcOffset() / 60;
        let param = { ...this.queryData, timeZone: timeZoneOffset };
        await getExport(param, "export.xlsx");
        this.exportLoading = false;
      } catch (error) {
        console.error(error);
        this.exportLoading = false;
      }
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "480px");
    }
  },
  mounted() {
    let d = [];
    d = [
      new Date(new Date().toLocaleDateString()).getTime() -
        14 * 24 * 60 * 60 * 1000,
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    ];
    this.userLevelUpdateTime = d;
    this.userLastBetTime = d;
    this.queryData.userLevelUpdateStartTime = d[0];
    this.queryData.userLevelUpdateEndTime = d[1];
    this.queryData.lastBetStartTime = d[0];
    this.queryData.lastBetEndTime = d[1];
    this.handleOddsDropFactor();
    this.getRiskLevel();
    this.getLableList();
    this.getLevelList();
    this.getUserQueryRequest();
    this.getMerchatList();
    //this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
      self.$refs.table.bodyWrapper.addEventListener("scroll", () => {
        self.statusPopoverVisible = false;
      });
    });
  },
  unmounted() {
    window.onresize = null;
    this.$refs.table.bodyWrapper.removeEventListener("scroll");
  },
  components: {
    dia,
    Empty
  }
};
</script>
<style lang="scss" scoped>
.query-item{
  display: flex;
  justify-content: space-around;
  align-items: center;
  .remarkInput{
    width: auto;
  }
}
.search-number{
  width: 300px;
  float: right;
  .query-btn{
    width: 50px;
    margin-top: 10px;
  }
}
.middle-btn {
  margin: 18px 15px;
}
.table,
.pagination-wrapper {
  margin: 18px 15px 0;

  .pagination-btn {
    width: 55%;
  }
  .parlay-pagination {
    width: 45%;
  }
}

.is-text-switch {
  cursor: pointer;
  .el-switch {
    position: relative;

    &::after {
      content: "No";
      display: block;
      position: absolute;
      right: 8px;
      color: #fff;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
    }

    &.is-checked::after {
      content: "Yes";
      left: -6px;
    }
  }
}

.status-popver {
  display: flex;
  align-items: center;
  height: 30px;
  cursor: pointer;

  .tag {
    width: 75px;
    text-align: center;
    border-radius: 5px;
    padding: 5px 0;
    color: #fff;
    margin-right: 17px;
    height: 22px;
  }

  .tag--active {
    background: #4d7812;
  }

  .tag--suspend {
    background: #bc4f2d;
  }

  .tag--block {
    background: #333333;
  }
}

.el-popover {
  .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow-y: auto;
    margin-bottom: 10px;
  }

  .el-dropdown-menu__item {
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #f5f7fa;
    }

    &.is-selected {
      font-weight: bold;
      color: #00a791;
    }

    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      pointer-events: inherit;
    }
  }

  .popover-buttons {
    .el-button {
      width: 62px;
      height: 24px;
    }

    .el-button--primary {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: #ffffff;
      background: #00a791;
      border-radius: 5px;
    }

    .el-button--text {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: #999999;
    }
  }
}

.el-icon-arrow-down {
  color: #7d8ba9;
}

.remark-warp {
  .title {
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    color: #333333;
    margin-bottom: 5px;
  }

  /deep/.el-textarea__inner {
    border: 1px solid #ebedf3 !important;
    border-radius: 5px;
    padding: 8px 7px;
  }
}

.level-name-cell {
  text-align: center;
  border-radius: 4px;
  padding: 2.5px 15px;
  height: 18px;
  font-size: 12px;
  line-height: 12px;
  span {
    display: inline-block;
    max-width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.check-hint {
  max-width: 25px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e1554f;
  border: 1px solid #e1554f;
  border-radius: 10px;
  font-weight: bold;
  margin-top: 5px;
  cursor: pointer;
}

.check-popper {
  left: 300px !important;
  .text {
    color: #333;
  }
  .update-time {
    font-size: 12px;
    line-height: 12px;
    color: #999999;
  }
}
.icon-status {
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
/deep/.el-pagination__total {
  margin-right: 2px !important;
}
/deep/.el-dialog__wrapper {
  .el-input__inner {
    width: 280px !important;
  }
}
.odds-tag {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  background: #00a791;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.label-box {
  /deep/.el-input {
    width: 290px !important;
  }
}
.level-box {
  /deep/.el-input {
    width: 190px !important;
    margin-right: 10px;
  }
}
.userLevelExpire-box {
  /deep/.el-checkbox__label {
    width: 75px !important;
    font-weight: normal;
    font-size: 12px;
  }
}
.overflow-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
